module.exports = __webpack_public_path__ + "static/media/star-half-alt.2af279c5.svg";